module.exports = __webpack_public_path__ + "img/22_10.90d82fdb.png";